import { isProd, isSandbox } from "config/base"

import { addresses as prodAddresses } from "./contract-addresses.prod"
import { addresses as sandboxAddresses } from "./contract-addresses.sandbox"
import { addresses as stagingAddresses } from "./contract-addresses.staging"

const botGenesisAddress = "0x4dF461F8c22c0bfB40a51560597D5b946d869d5c"
const botBridgeAddress = "0xB0e1aA072F888db78Ac90d562748351719Ac511C"

const botClassicAddress = "0xf7a6e15dfd5cdd9ef12711bd757a9b6021abf643"
const botWClassicAddress = "0xc0bf6533fe18394a581aa38de831c4ecc64cbe55"
const zeroAddress = "0x0000000000000000000000000000000000000000"
const usdc = "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"

export type ContractAddresses = {
  BITS: string
  OIL: string

  AllianceStaking: string
  Bot: string
  BotMetadata: string
  BotMinter: string
  BotRevealer: string
  BotTeams: string
  BotToken: string
  BotUpgrader: string
  BotRent: string
  MarketPlaceProxy: string
  Reward: string

  Ship: string
  ShipMetadata: string
  ShipFuser: string
  ShipRevealer: string
  ShipTeams: string

  BotGenesis: string
  BotBridge: string
  BotClassic: string
  BotClassicWrapped: string
  ZeroAddress: string

  LpBitUSDC: string
  LpOilUSDC: string
  LpStakingBitUsdc: string
  LpStakingOilUsdc: string

  VotingEscrow: string

  USDC: string

  DamageFix: string
  BotShipPool: string
}

const staging: ContractAddresses = {
  BITS: stagingAddresses.Bit,
  OIL: stagingAddresses.Oil,

  AllianceStaking: stagingAddresses.AllianceStaking,
  Bot: stagingAddresses.Bot,
  BotMetadata: stagingAddresses.BotMetadata,
  BotMinter: stagingAddresses.BotMinter,
  BotRevealer: stagingAddresses.BotRevealer,
  BotTeams: stagingAddresses.BotTeam,
  BotToken: stagingAddresses.Bot,
  BotUpgrader: stagingAddresses.BotUpgrader,
  BotRent: stagingAddresses.BotRent,
  MarketPlaceProxy: stagingAddresses.Marketplace,
  Reward: stagingAddresses.Reward,

  BotClassic: botClassicAddress,
  BotClassicWrapped: botWClassicAddress,
  BotGenesis: botGenesisAddress,
  BotBridge: botBridgeAddress,

  Ship: stagingAddresses.Ship,
  ShipMetadata: stagingAddresses.ShipMetadata,
  ShipFuser: stagingAddresses.ShipMinter,
  ShipRevealer: stagingAddresses.ShipRevealer,
  ShipTeams: stagingAddresses.ShipTeam,

  ZeroAddress: zeroAddress,

  LpBitUSDC: "0x83D35A31EBA8957F3598B9251503f8C95Ec26543",
  LpOilUSDC: "0x3e7F2420d006b988aB4e845D4C9da8a1c9a0980d",
  LpStakingBitUsdc: "0x63097E0D3A88Ca80F644DFe9D5fEa876e5Ed3dbB",
  LpStakingOilUsdc: "0x7b7f8E5529E56F9805dDfd9d5906825F485C4135",

  VotingEscrow: stagingAddresses.VotingEscrow,

  USDC: usdc,

  DamageFix: stagingAddresses.DamageFix,
  BotShipPool: stagingAddresses.BotShipPool,
}

const sandbox: ContractAddresses = {
  BITS: sandboxAddresses.Bit,
  OIL: sandboxAddresses.Oil,

  AllianceStaking: sandboxAddresses.AllianceStaking,
  Bot: sandboxAddresses.Bot,
  BotMetadata: sandboxAddresses.BotMetadata,
  BotMinter: sandboxAddresses.BotMinter,
  BotRevealer: sandboxAddresses.BotRevealer,
  BotTeams: sandboxAddresses.BotTeam,
  BotToken: sandboxAddresses.Bot,
  BotUpgrader: sandboxAddresses.BotUpgrader,
  BotRent: sandboxAddresses.BotRent,
  MarketPlaceProxy: sandboxAddresses.Marketplace,
  Reward: sandboxAddresses.Reward,

  BotClassic: botClassicAddress,
  BotClassicWrapped: botWClassicAddress,
  BotGenesis: botGenesisAddress,
  BotBridge: botBridgeAddress,

  Ship: sandboxAddresses.Ship,
  ShipMetadata: sandboxAddresses.ShipMetadata,
  ShipFuser: sandboxAddresses.ShipMinter,
  ShipRevealer: sandboxAddresses.ShipRevealer,
  ShipTeams: sandboxAddresses.ShipTeam,
  ZeroAddress: zeroAddress,

  LpBitUSDC: "0xfb6009ab0adf66e2d06c2f792956bbe0442dff41",
  LpOilUSDC: "0x99f8ec56f769335a74280ce38c47f22526b355d8",
  LpStakingBitUsdc: "0x93407312f0C054E285B97403F22723e992C32F6D",
  LpStakingOilUsdc: "0x57cf4E851Cd73437bDa3e6Ed723A2d019A668D31",

  VotingEscrow: sandboxAddresses.VotingEscrow,

  USDC: usdc,

  DamageFix: sandboxAddresses.DamageFix,
  BotShipPool: sandboxAddresses.BotShipPool,
}

const prod: ContractAddresses = {
  BITS: prodAddresses.Bit,
  OIL: prodAddresses.Oil,

  AllianceStaking: prodAddresses.AllianceStaking,
  Bot: prodAddresses.Bot,
  BotMetadata: prodAddresses.BotMetadata,
  BotMinter: prodAddresses.BotMinter,
  BotRevealer: prodAddresses.BotRevealer,
  BotTeams: prodAddresses.BotTeam,
  BotToken: prodAddresses.Bot,
  BotUpgrader: prodAddresses.BotUpgrader,
  BotRent: prodAddresses.BotRent,
  MarketPlaceProxy: prodAddresses.Marketplace,
  Reward: prodAddresses.Reward,

  BotClassic: botClassicAddress,
  BotClassicWrapped: botWClassicAddress,
  BotGenesis: botGenesisAddress,
  BotBridge: botBridgeAddress,

  Ship: prodAddresses.Ship,
  ShipMetadata: prodAddresses.ShipMetadata,
  ShipFuser: prodAddresses.ShipMinter,
  ShipRevealer: prodAddresses.ShipRevealer,
  ShipTeams: prodAddresses.ShipTeam,
  ZeroAddress: zeroAddress,

  LpBitUSDC: "0x970ab581d1b9d2B0392DEA04996cb933118436FC",
  LpOilUSDC: "0x109aa88Dc2408F33Bc51F62321b52c00b8b1A44F",
  LpStakingBitUsdc: "0xC378F348F38A811b3c1eF082a638711E415e4d9d",
  LpStakingOilUsdc: "0xE6c50aA28a4d1dC07B213F3f8e7b512046c3239F",

  VotingEscrow: prodAddresses.VotingEscrow,

  USDC: usdc,

  DamageFix: prodAddresses.DamageFix,
  BotShipPool: prodAddresses.BotShipPool, // prodAddresses.BotShipPool,
}

export const contractAddresses = isProd ? prod : isSandbox ? sandbox : staging
